import { jsx as _jsx } from "react/jsx-runtime";
import { Divider } from 'antd';
import styled from '../../../../styled';
const UserMenuDivider = ({ className }) => {
    return _jsx(Divider, { className: className });
};
export default styled(UserMenuDivider) `
  margin-top: 7px;
  margin-bottom: 7px;
`;
